const breadcrumbsHome = { name: 'Home', pathName: '/' }
const breadcrumbsArtefatos = { name: 'Artefatos', pathName: '/artefatos' }

export default [
  {
    path: '/artefatos',
    component: () => import('@/modules/html-artifacts/views/HtmlArtifacts.vue'),
    meta: {
      title: 'Artefatos',
      breadcrumbs: [breadcrumbsHome, breadcrumbsArtefatos]
    }
  },
  {
    path: '/artefatos/s/:slug',
    component: () => import('@/modules/html-artifacts/views/RenderHtmlArtifact.vue'),
    meta: {
      title: 'Visualizar Artefato',
      breadcrumbs: [breadcrumbsHome, breadcrumbsArtefatos]
    }
  },
  {
    path: '/artefatos/:id',
    component: () => import('@/modules/html-artifacts/views/RenderHtmlArtifact.vue'),
    meta: {
      title: 'Visualizar Artefato',
      breadcrumbs: [breadcrumbsHome, breadcrumbsArtefatos]
    }
  }
]
